import React, { useState } from 'react';
import {
  BoxStyled,
  GridStyled,
  BMRSection,
  BMRTitle,
  BMRValue,
  TypographyStyledHeader
} from './style';
import { Selection } from '../shared/selection';
import { StressFactor } from './stressFactor';
import { Routes, Route } from 'react-router-dom';
import { ActivityFactor } from './activityFactor';
import { UnknownAction } from '@reduxjs/toolkit';
import infoIcon from '../../../assets/icons/infoIcon.svg';
import { Button, Container, Modal } from '@mui/material';
import { StressFactorType } from '../../../shared/shared.interfaces';
import { NavigationButtons } from '../../../shared/components/navigationButtons';
import { ActivityFactorPALSelectType } from '../../../shared/shared.interfaces';
import { AddOnInfoModal } from '../../../shared/components/modal/addOnInfoModal';

const SharedIndex = ({
  title,
  BMRVal,
  summary,
  selection,
  stressFactor,
  nextPageRoute,
  activityFactor,
  activityFactorPAL_Input,
  activityFactorPAL_Select,
  setSummaryVal,
  setStressFactor,
  setActivityFactor,
  handleSelectionToggle,
  setActivityFactorPAL_Input,
  setActivityFactorPAL_Select
}: {
  title: string;
  BMRVal: number;
  summary: number;
  nextPageRoute: string;
  stressFactor?: StressFactorType;
  activityFactor: { optionSelected: string; value: number };
  selection: { stressFactor: boolean; activityFactor: boolean };
  activityFactorPAL_Input: { PALRatio: number; value: number };
  activityFactorPAL_Select: ActivityFactorPALSelectType;
  setSummaryVal: (val: number) => UnknownAction;
  setStressFactor?: (stress: StressFactorType) => UnknownAction;
  setActivityFactorPAL_Input: (val: {
    PALRatio: number;
    value: number;
  }) => UnknownAction;
  setActivityFactor: (val: {
    optionSelected: string;
    value: number;
  }) => UnknownAction;
  setActivityFactorPAL_Select: (
    val: ActivityFactorPALSelectType
  ) => UnknownAction;
  handleSelectionToggle: (selection: {
    stressFactor: boolean;
    activityFactor: boolean;
  }) => UnknownAction;
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <BoxStyled>
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'row',
            padding: '0 !important'
          }}
        >
          <TypographyStyledHeader>{title}</TypographyStyledHeader>
          <Button
            onClick={() => handleOpen()}
            sx={{ height: '1.25rem', minWidth: '1.25rem', padding: 0 }}
          >
            <img src={infoIcon} alt={'infoIcon'} />
          </Button>
        </Container>
        <GridStyled container className="width-100">
          <BMRSection>
            <BMRTitle variant="h2">{'BMR (kcal/day):'}</BMRTitle>
            <BMRValue>{BMRVal}</BMRValue>
          </BMRSection>
        </GridStyled>
        <Routes>
          <Route
            index
            element={
              <Selection
                selection={selection}
                handleSelectionToggle={handleSelectionToggle}
              />
            }
          />
          {stressFactor && setStressFactor && (
            <Route
              path="stressFactor"
              element={
                <StressFactor
                  BMRVal={BMRVal}
                  stressFactor={stressFactor}
                  setStressFactor={setStressFactor}
                />
              }
            />
          )}
          <Route
            path="ActivityOrPAL"
            element={
              <ActivityFactor
                BMRVal={BMRVal}
                summary={summary}
                activityFactor={activityFactor}
                activityFactorPAL_Input={activityFactorPAL_Input}
                activityFactorPAL_Select={activityFactorPAL_Select}
                setSummaryVal={setSummaryVal}
                setActivityFactor={setActivityFactor}
                setActivityFactorPAL_Input={setActivityFactorPAL_Input}
                setActivityFactorPAL_Select={setActivityFactorPAL_Select}
              />
            }
          />
        </Routes>
      </BoxStyled>
      <NavigationButtons nextDisabled={false} nextRoute={nextPageRoute} />
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddOnInfoModal
          heading1={`BMR`}
          description1={` = Basal Metabolic Rate`}
          heading2={`PAL`}
          description2={` = Physical Activity Level`}
          title={`Reference:`}
          content={`Irish Nutrition and Dietetic Institute (2022) Nutrition Support
        Reference Guide.`}
          onClose={handleClose}
        />
      </Modal>
    </>
  );
};

export { SharedIndex };
